import Vue from 'vue'
import VueRouter from 'vue-router'
import { isLoggedIn } from '@/api/auth'
import { trackPageView } from '@/api/analytics'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'welcome',
    component: () => import('../views/WelcomeView.vue'),
    meta: { public: true }
  },
  {
    path: '/app',
    component: () => import('../views/BlogShell.vue'),
    meta: { requiresAuth: true },
    redirect: '/app/paintings',
    children: [
      { path: 'paintings', name: 'paintings', component: () => import('../views/GalleryView.vue'), props: { kind: 'painting' } },
      { path: 'photos', name: 'photos', component: () => import('../views/GalleryView.vue'), props: { kind: 'photo' } },
      { path: 'documents', name: 'documents', component: () => import('../views/DocumentView.vue') },
      { path: 'messages', name: 'messages', component: () => import('../views/MessageView.vue') },
      { path: 'downloads', name: 'downloads', component: () => import('../views/DownloadView.vue') },
      { path: 'profile', name: 'profile', component: () => import('../views/ProfileView.vue') }
    ]
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.public) return next()
  if (to.matched.some(item => item.meta.requiresAuth) && !isLoggedIn()) {
    return next('/')
  }
  next()
})

router.afterEach(to => {
  if (to.matched.some(item => item.meta.requiresAuth)) {
    trackPageView(to.fullPath)
  }
})

export default router
